

import CatalogList from '~/components/header/mobile/CatalogList';

export default {
  name: 'LazyCatalogContent',
  components: { CatalogList },
  props: {
    catalog: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ['clickButton'],

  methods: {
    clickButton() {
      this.$emit('clickButton');
    },
  },
};
